import { EditDeliveryContainerDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { Locker } from '../../../lockers/models/locker.model';
import { DeliveryContainerSettingsForm } from './form';

type Dimensions = { widthCm?: number; heightCm?: number; depthCm?: number };

export class DeliveryContainerSettingsFormOutput {
  name?: string;
  status?: string;
  isConsideredLow?: boolean;
  sizeDescription?: string;
  innerDimensions?: Dimensions;
  outerDimensions?: Dimensions;

  constructor(form: DeliveryContainerSettingsForm) {
    if (form.name !== undefined) this.name = form.name;
    if (form.status !== undefined) this.status = form.status;
    if (form.isConsideredLow !== undefined) this.isConsideredLow = form.isConsideredLow;
    if (form.sizeDescription !== undefined) this.sizeDescription = form.sizeDescription;
    if (form.innerDimensions !== undefined) this.innerDimensions = form.innerDimensions;
    if (form.outerDimensions !== undefined) this.outerDimensions = form.outerDimensions;
  }

  static FromLockerDto(locker: Locker): DeliveryContainerSettingsForm {
    return {
      name: locker.name,
      status: locker.status,
      isConsideredLow: locker.isConsideredLow,
      sizeDescription: locker.sizeDescription,
      innerDimensions: locker.innerDimensions,
      outerDimensions: locker.outerDimensions
    };
  }

  static ToEditLockerDto(output: DeliveryContainerSettingsFormOutput): EditDeliveryContainerDto {
    return {
      name: output.name,
      isConsideredLow: output.isConsideredLow
    };
  }
}
